import { v4 as uuidv4 } from "uuid";

import { IApiMutationFunction } from "../../utils";
import { CertificationIssuerEnvironment, ICertificationIssuerResource } from "../types";
import { createCertificationIssuerMutationHook } from "./createCertificationIssuerMutationHook";

export type ICertificationIssuerCreateMutationParameters = {
    uuid?: string;
    name: string;
    url: string;
    apiKey: string;
    environment: CertificationIssuerEnvironment;
};
export type ICertificationIssuerCreateMutationResult = ICertificationIssuerResource;

export const certificationIssuerCreateMutation: IApiMutationFunction<ICertificationIssuerCreateMutationParameters> = ({
    uuid: providedUuid,
    name,
    url,
    apiKey,
    environment,
}) => ({
    method: "POST",
    url: "/certification_issuers",
    data: {
        uuid: providedUuid ?? uuidv4(),
        name,
        url,
        apiKey,
        environment,
    },
});

export const useCertificationIssuerCreateMutation = createCertificationIssuerMutationHook<
    ICertificationIssuerCreateMutationParameters,
    ICertificationIssuerCreateMutationResult
>(certificationIssuerCreateMutation);
